import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";


const BottomCurved = () => {
  const theme = useTheme();

  return (
    <Box component="div" sx={{ position: 'absolute', top: '345px', width: '100%', color: theme.palette.mode === 'light' ? '#f5f8fa' : '#151521' }}>
      <svg width="100%" height="56px" viewBox="0 0 100 100" version="1.1" preserveAspectRatio="none" className="">
        <path d="M0,0 C16.6666667,66 33.3333333,99 50,99 C66.6666667,99 83.3333333,66 100,0 L100,100 L0,100 L0,0 Z" fill="currentColor"></path>
      </svg>
    </Box>
  );
}

export default BottomCurved;
